import Card from "react-bootstrap/Card";
import classes from "./Product.module.css";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { useContext, useState, useEffect } from "react";
import { CartContext } from "./CartContext";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { blurContext } from "./BlurContext";

function Product(props) {
	//initilaize navigation hook
	const navigation = useNavigate("");

	// function to navigate to product page
	const viewProduct = () => {
		navigation("/products/" + props.id);
	};

	// state for showing select size modal
	const [showModal, setShowModal] = useState(false);

	//state for storing size selected
	const [size, setSize] = useState("");

	//load cart context
	const { cartItems, addProduct, changeQuantity, removeProduct } =
		useContext(CartContext);

	//state for storing quantity
	const [counter, setCounter] = useState(1);

	// check if a product is already in cart by comparing the id to the size selected
	const productInCart = cartItems.find(
		(product) => product.id === props.id && product.size === size
	);

	//import blur context
	const { changeBlurState } = useContext(blurContext);

	// effect to listen for press of backward or forward buttons in the browser to change blur state to false
	useEffect(() => {
		return () =>
			window.addEventListener("popstate", () => changeBlurState(false));
	}, [changeBlurState]);

	//update state if product is in cart
	useEffect(() => {
		if (!productInCart) {
			setCounter(1);
			return;
		}
		setSize(productInCart?.size);
		setCounter(productInCart?.quantity);
	}, [productInCart]);

	//update product in cart if state changes
	useEffect(() => {
		if (!productInCart || productInCart?.quantity === counter) {
			return;
		}
		changeQuantity(props.id, counter, size);
	}, [changeQuantity, props.id, counter, size, productInCart]);

	//add product to cart
	const addToCart = () => {
		if (!size) {
			return;
		}

		changeBlurState(false);
		setShowModal(false);
		addProduct(props.id, counter, size);
	};

	const increment = () => {
		setCounter((prevCnt) => prevCnt + 1);
	};

	const decrement = () => {
		if (counter > 0) {
			setCounter((prevCnt) => prevCnt - 1);
		}
	};

	return (
		<>
			<div
				className={classes.main}
				title="Click to view details"
				onClick={viewProduct}
			>
				<div
					className={classes.img}
					style={{ backgroundImage: `url("${props.itemImg[0]}")` }}
				></div>
				<div>
					<Card.Text className={classes.name}>
						{props.itemName}
					</Card.Text>

					<Card.Text className={classes.price}>
						${props.itemPrice}
					</Card.Text>
				</div>

				<div className={classes.cartButton}>
					<Button
						variant="success"
						className="rounded-1"
						onClick={(event) => {
							setShowModal(true);
							changeBlurState(true);
							event.stopPropagation();
						}}
					>
						Add to cart
					</Button>
				</div>
			</div>

			{/*Modal for selecting size*/}
			<Modal
				show={showModal}
				onHide={() => {
					setShowModal(false);
					changeBlurState(false);
				}}
				centered
				size="md"
			>
				<Modal.Header closeButton>
					<Modal.Title>Select Size</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ margin: "1rem" }}>
						<Form.Select
							className={classes.select}
							value={size}
							onChange={(e) => setSize(e.target.value)}
						>
							<option value={""}>Select Size</option>
							{props.sizes.map((size) => (
								<option key={size.sku} value={size.sku}>
									{size.name}
								</option>
							))}
						</Form.Select>
					</div>
					<div className={classes.quantity}>
						<p>Quantity</p>

						<div className={classes.quantityBtnContainer}>
							<Button
								onClick={decrement}
								disabled={counter === 1}
							>
								-
							</Button>
							<p>{counter}</p>
							<Button onClick={increment}>+</Button>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					{productInCart ? (
						<Button
							variant="danger"
							className="rounded-1"
							onClick={() => removeProduct(props.id, size)}
						>
							Remove
						</Button>
					) : (
						<button
							disabled={size ? false : true}
							className={classes.modalButton}
							onClick={addToCart}
						>
							Add to cart
						</button>
					)}
				</Modal.Footer>
			</Modal>
		</>
	);
}
export default Product;
